import "./Services.css";

const services = [
  { title: "دهانات أبواب حديد", href: "/paint/iron-doors" },
  { title: "دهانات أبواب حي القدس", href: "/paint/jerusalem-doors" },
  { title: "دهانات أبواب خارجية", href: "/paint/exterior-doors" },
  { title: "دهانات أبواب خشب", href: "/paint/wooden-doors" },
  { title: "دهانات أبواب خشب داخلية", href: "/paint/interior-wooden-doors" },
  { title: "دهانات أبواب زيتية", href: "/paint/oil-doors" },
  { title: "دهانات أبواب في الجبيلة", href: "/paint/jubailah-doors" },
  { title: "دهانات أبواب في الخرج", href: "/paint/al-kharj-doors" },
  { title: "دهانات أبواب في الخليج", href: "/paint/gulf-doors" },
  { title: "دهانات أبواب في الروضة", href: "/paint/ralwada-doors" },
  { title: "دهانات أبواب في السويد", href: "/paint/sweden-doors" },
  { title: "دهانات أبواب في الشفاء", href: "/paint/al-shifa-doors" },
  { title: "دهانات أبواب في الصحافة", href: "/paint/al-press-doors" },
  { title: "دهانات أبواب في الغدير", href: "/paint/al-ghadeer-doors" },
  { title: "دهانات أبواب في الملز", href: "/paint/al-malaz-doors" },
  { title: "دهانات أبواب في النخيل", href: "/paint/al-nakheel-doors" },
  { title: "دهانات أبواب في النفل", href: "/paint/al-nafl-doors" },
  { title: "دهانات أبواب في عرقا", href: "/paint/araq-doors" },
  { title: "دهانات أبواب في لبن", href: "/paint/laban-doors" },
  { title: "دهانات أبواب مقاومة للحرائق", href: "/paint/fire-resistant-doors" },
  { title: "دهانات إيبوكسي", href: "/paint/epoxy" },
  { title: "دهانات ملكا", href: "/paint/malqa" },
  { title: "دهانات في حي اليارموك", href: "/paint/yarumok-doors" },
  { title: "دهانات في حي قرطبة", href: "/paint/qurtuba-doors" },
  { title: "دهانات في الرياض", href: "/paint/riyadh-doors" },
  { title: "دهانات في حي العوالي", href: "/paint/al-awali-doors" },
  { title: "دهانات في الرياض الشرقية", href: "/paint/east-riyadh" },
  { title: "دهانات في الرياض الشمالية", href: "/paint/north-riyadh" },
  { title: "دهانات في حي الصحافة", href: "/paint/al-sahafa" },
  { title: "دهانات في حي الملز", href: "/paint/al-malaz" },
  { title: "دهانات في حي الأمل", href: "/paint/al-hope" },
  { title: "دهانات في حي الفتح", href: "/paint/al-fath" },
  { title: "دهانات شاشات", href: "/paint/screen-decor" },
  { title: "دهانات جوتن الداخلية", href: "/paint/jotun-interior" },
  { title: "دهانات خارجية في السليمانية", href: "/paint/sulaymaniyah-exterior" },
  { title: "دهانات خارجية في الرياض الشمالية", href: "/paint/north-riyadh-exterior" },
  { title: "دهانات داخلية في الرياض", href: "/paint/riyadh-interior" },
  { title: "دهانات داخلية في حي الملز", href: "/paint/al-malaz-interior" },
];

export default function Services() {
  return (
    <section className="service-tags1">
      <h1 className="section-title1">خدمات دهانات وديكورات الرياض</h1>
      <div className="tag-list1">
        {services.map((service, index) => (
          <a
            href={service.href}
            className="service-tag1"
            key={index}
            target="_blank"
            rel="noopener noreferrer"
          >
            {service.title}
          </a>
        ))}
      </div>
    </section>
  );
}
